import ConfiguracionEmpleado from 'components/empleados/ConfiguracionEmpleado'
import React from 'react'
import { useParams } from 'react-router-dom'
import { Card, CardBody, CardHeader } from 'reactstrap'

function ViewConfiguracionEmpleado() {
    const {id} = useParams();
  return (
    <Card>
        <CardHeader>
            Configuración empleado:
        </CardHeader>
        <CardBody>
            <ConfiguracionEmpleado empleadoId={id}></ConfiguracionEmpleado>
        </CardBody>
    </Card>
  )
}

export default ViewConfiguracionEmpleado